<template>
    <BreadCrumb PageTitle="Point des paiements des autres recettes" />
    <ListePaiementAutreRecette />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListePaiementAutreRecette from "@/components/PaiementRecette/ListePaiementAutreRecette.vue";
    export default defineComponent({
      name: "ListePaiementAutreRecettePage",
      components: {
        BreadCrumb,
        ListePaiementAutreRecette,
      },
    });
  </script>